import app from "./app";
import auth from "./auth";
import docs from "./docs";
import embed from "./embed";
import errors from "./errors";
import global from "./global";
import landing from "./landing";
const en = { auth, errors, global, app, docs, landing, embed };
export default en;
